import React, { useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
const FAQS = [{
  q: 'How do I get access after purchasing?',
  a: "Immediately after checkout you'll receive a confirmation email with your login to our private members area. Everything is digital — HD videos, step-by-step guides and printable checklists — accessible on any device, instantly."
}, {
  q: "I've already failed at resin multiple times. Will this actually be different?",
  a: "That's exactly who this was designed for. If you've failed before, it means you were learning without a system — not that you can't do it. The protocols and error correction guide are built specifically for people who've already hit walls."
}, {
  q: 'Do I need expensive materials to start?',
  a: "No. You only need basic resin, a mold, a heat gun or lighter, and gloves — all available on Amazon for under $40. The system is designed to work with beginner-level tools. We even include a recommended starter kit list so you don't overbuy."
}, {
  q: "I don't have a workshop or dedicated space. Can I still do this?",
  a: "Yes. The program includes a workspace setup module for home environments — kitchen table, spare room, any flat surface with ventilation. You don't need a studio."
}, {
  q: 'Is resin safe to use at home?',
  a: 'With the right precautions, absolutely. The Safety & Setup module is the first thing you watch. We cover PPE, ventilation, and a safe-handling checklist so you can work confidently from home.'
}, {
  q: "I'm not artistic or creative. Will I be able to do this?",
  a: 'This program is deliberately not about being artistic. It\'s about following a technical process correctly. Our most successful students describe themselves as "not creative at all" — because they follow the steps, they don\'t improvise.'
}, {
  q: 'Is there a monthly fee?',
  a: 'No. This is a one-time payment. You get lifetime access with no recurring charges, no subscription, no expiry date.'
}, {
  q: "What if I can't finish all 7 days in one week?",
  a: 'No problem. The "7 days" is the structure, not a deadline. You have lifetime access. Many students do it over 2–3 weeks around their schedule. Everything waits for you.'
}, {
  q: 'Can I sell the pieces I make with this system?',
  a: "Absolutely — that's one of the main goals. The guided project and sell-ready roadmap are specifically designed to get you from creating pieces to listing them."
}, {
  q: 'How does the 60-day guarantee work?',
  a: "Simple. Go through the 7 days. If you're not getting better results, email us within 60 days for a full refund. No conditions, no questions, no fine print."
}, {
  q: "Why is the price so low? What's the catch?",
  a: "No catch. We're in a launch window and want to get results into as many hands as possible. After this window, the price returns to $67. If you're reading this, you're here at the right time."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full px-4 md:px-8 max-w-4xl mx-auto flex flex-col items-center" data-id="element-86">
      <FadeIn className="text-center mb-16" data-id="element-87">
        <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-88">
          Got Questions?
        </span>
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-cream mb-6" data-id="element-89">
          Frequently Asked Questions
        </h2>
      </FadeIn>

      <div className="w-full flex flex-col gap-4" data-id="element-90">
        {FAQS.map((faq, index) => {
        const isOpen = openIndex === index;
        return <FadeIn key={index} delay={index * 50} direction="up" className="w-full" data-id="element-91">
              <div className={`bg-darkCard border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-amber/50 shadow-lg shadow-amber/5' : 'border-darkBorder hover:border-amber/30'}`} data-id="element-92">
                <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-amber/50" aria-expanded={isOpen} data-id="element-93">
                  <h3 className={`font-lato font-bold text-lg md:text-xl pr-8 transition-colors duration-300 ${isOpen ? 'text-amber' : 'text-cream'}`} data-id="element-94">
                    {faq.q}
                  </h3>
                  <span className={`flex-shrink-0 w-8 h-8 rounded-full border flex items-center justify-center transition-all duration-300 ${isOpen ? 'border-amber text-amber rotate-180 bg-amber/10' : 'border-darkBorder text-cream/50'}`} data-id="element-95">
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-96">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-97" />
                    </svg>
                  </span>
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-98">
                  <div className="px-6 pb-6 pt-2 font-lato text-cream/70 leading-relaxed border-t border-darkBorder/50 mx-6" data-id="element-99">
                    {faq.a}
                  </div>
                </div>
              </div>
            </FadeIn>;
      })}
      </div>
    </section>;
}